import SunEditorInstance from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import "./style.css";
import Constants from "../../App/Variables/Constants";
const SunEditor = ({ value, setValue, onFocus, onBlur }) => {
    return (
        <SunEditorInstance
            style={{ overflow: 'visible !important' }}
            setContents={value}
            onChange={setValue}
            setAllPlugins={true}
            setOptions={setOptions()}
            autoFocus={false}
            onSave={() => { }}
            hideToolbar={false}
            disableToolbar={false}
            height="100%"
            onFocus={onFocus}
            onBlur={onBlur}
            setDefaultStyle="z-index: 0 ;min-width:100%; overflow: auto !important"
        />
    );
};

export default SunEditor;

const fonts = [
    "Logical",
    "Salesforce Sans",
    "Garamond",
    "Sans-Serif",
    "Serif",
    "Times New Roman",
    "Helvetica",
    "Arial",
    "Comic Sans MS",
    "Courier New",
    "Impact",
    "Georgia",
    "Tahoma",
    "Trebuchet MS",
    "Verdana",
].sort();
const uploadUrl = Constants.postUrls.saveFile;
const IconBox = (src) =>
    `<div style="display:flex;justify-content:center;align-items:center" ><img width="20" height="20" src="${src}" </div>`;
const videoIconSrc =
    `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAABHklEQVRoge2ZTWrCQBiGn3QhHsJtwRN4AvfFEE/RmwhCt3oE71DU7HuCnkIiVLDULvxhDImZNDXzlb4PvGQzH7xPhixmAkIIIYS4IgFSYAscWswWWAPxb0i8tFy+LNMmEokBATejn4qkBsq7WdXs3wGeof1voiqZp0AEjIH301zw4kWpYgi85WdCl64jMgBey2ZCl/YR6QML4OvWTOjSt0R6wAzYV81EJW8gNNHp+QF0fQcsi3h3e7hTkdaRiDUkYg2JWEMi1pCINayL7HwXWhd5BObAp8/i0GePf3GwyvPnj7p5Ci8fMgPF3Ww8RKDgOmhtoLybpafImcsFXWygvJunmiJXTA0IHIBJE4kzI47bGuK3wpKGOyGEEEII4BvLBpZz2nQq/AAAAABJRU5ErkJggg==` ||
    `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAAlElEQVRIie3VQQrCMBSE4a9uPYWCd7EewKVexUN5IiN6BXd1IYGKwRqSQpH+8DbhZSbJwAszGewQ0BVWQJsyqCEe6xJFm55BV3D7FA0sKot+MBmDFY64l5h9Cy2yxAmPgf5knjnNG5zHNIjsh/aMHnKfSTzRaCGvccDtB+E3g3lUZBlcK+qG1GLrNcdr/AXbiof9d565KJucZq0/2wAAAABJRU5ErkJggg==`;
const moreIconSrc = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAAwUlEQVRoge3W0QqCMBjF8T9d6DvkG1b4VPUqpRdWNz3Juq4upgNFnaNgk84PPhDZObAhQxARERERERH5CzlQAhXwbKcCDkC2gjwABXAH3hNza9ekmgfsScyVdHNl/GRi551yQUk3+wTzTh1QdEkw75iAIpNSfjO3K4/XF9mf54cbeQQUja2Nlh9u5BRQdBx5Fzvv5Nh72vd9NkxfnzHzPYWnrAG2Ced7MuzvwBl7O5j2eceyX4TYeREREREREZG1+wCLYfUgbLqSzgAAAABJRU5ErkJggg==`;
const linkIconSrc = `data:image/png;base64,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`;
export const setOptions = () => {
    const oneMB = 1_000_000;
    return {
        icons: {
            video: IconBox(videoIconSrc),
            more_plus: IconBox(moreIconSrc),
            link: IconBox(linkIconSrc),
        },
        // toolbarContainer: "div",
        // fullScreenOffset: 10,
        defaultStyle:
            "border:0px solid red; padding:20px;z-index:2147483640,font-family:'Inter', 'Times New Roman', Times, serif",
        stickyToolbar: 1,
        // paragraphStyles: ["font-family:Nunito, 'Times New Roman', Times, serif"],
        textStyles: ["font-family:'Inter', 'Times New Roman', Times, serif"],
        resizingBar: true,
        resizeEnable: true,
        // charCounterLabel: "Total char",

        // alignItems: ["center"],
        defaultTag: "h1",
        // minHeight: "100%",
        // maxHeight: "100%",
        width: "auto",
        showPathLabel: false,

        // charCounter: true,
        // charCounterType: "char",

        font: ["Inter", ...fonts],

        buttonList: buttonList2(),

        mediaAutoSelect: true,
        // Image,video & audio config
        imageUploadHeader: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        // imageUploadSizeLimit: oneMB * 4,
        imageMultipleFile: true,
        imageUploadUrl: uploadUrl,
        imageFileInput: true,
        imageUrlInput: true,
        imageResizing: true,
        imageHeightShow: true,
        imageAlignShow: true,
        imageAccept: ".jpg, .png, .web, .gif",

        videoFileInput: true,
        videoUrlInput: true,
        videoUploadHeader: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        videoUploadUrl: uploadUrl,
        // videoUploadSizeLimit: 4 * oneMB,
        videoMultipleFile: false,

        audioFileInput: true,
        audioUrlInput: true,
        audioUploadHeader: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        audioUploadUrl: uploadUrl,
        // audioUploadSizeLimit: 4 * oneMB,
        audioMultipleFile: false,
    };
};
function buttonList2() {
    return [
        // ["save", "undo", "redo"],
        ["formatBlock", "bold", "italic", "underline", "align", "list", "link", "image", "video", "table", "audio", "-right",
            "font",
            "fontSize",
            "paragraphStyle",
            "blockquote",
            "strike",
            "subscript",
            "superscript",
            "fontColor",
            "hiliteColor",
            "textStyle",
            "removeFormat",
            "outdent",
            "indent",
            "horizontalRule",
            "lineHeight", "codeView"],
        // [],
        // [],
        // [
        // ],
    ];
}
function buttonList() {
    return [
        // ["save", "undo", "redo"],
        [
            "font",
            "fontSize",
            "formatBlock",
            "paragraphStyle",
            "blockquote",
            "bold",
            "underline",
            "italic",
            "strike",
            "subscript",
            "superscript",
            "fontColor",
            "hiliteColor",
            "textStyle",
        ],

        ["removeFormat"],
        ["outdent", "indent"],
        ["align", "horizontalRule", "list", "lineHeight"],
        ["table", "image", "video", "audio", "link"],
    ];
}

function responsieButtonList() {
    return [
        ["undo", "redo"],
        [
            ":p-More Paragraph-default.more_paragraph",
            "font",
            "fontSize",
            "formatBlock",
            "paragraphStyle",
            "blockquote",
        ],
        ["bold", "underline", "italic", "strike", "subscript", "superscript"],
        ["fontColor", "hiliteColor", "textStyle"],
        ["removeFormat"],
        ["outdent", "indent"],
        ["align", "horizontalRule", "list", "lineHeight"],
        ["-right", ":r-More Rich-default.more_plus", "table"],
        ["-right", "image", "video", "audio", "link"],

        // (min-width: 992)
        [
            "%992",
            [
                ["undo", "redo"],
                [
                    ":p-More Paragraph-default.more_paragraph",
                    "font",
                    "fontSize",
                    "formatBlock",
                    "paragraphStyle",
                    "blockquote",
                ],
                ["bold", "underline", "italic", "strike"],
                [
                    ":t-More Text-default.more_text",
                    "subscript",
                    "superscript",
                    "fontColor",
                    "hiliteColor",
                    "textStyle",
                ],
                ["removeFormat"],
                ["outdent", "indent"],
                ["align", "horizontalRule", "list", "lineHeight"],
                ["-right", ":i-More Misc-default.more_vertical"],
                [
                    "-right",
                    ":r-More Rich-default.more_plus",
                    "table",
                    "link",
                    "image",
                    "video",
                    "audio",
                ],
            ],
        ],
        // (min-width: 767)
        [
            "%767",
            [
                ["undo", "redo"],
                [
                    ":p-More Paragraph-default.more_paragraph",
                    "font",
                    "fontSize",
                    "formatBlock",
                    "paragraphStyle",
                    "blockquote",
                ],
                [
                    ":t-More Text-default.more_text",
                    "bold",
                    "underline",
                    "italic",
                    "strike",
                    "subscript",
                    "superscript",
                    "fontColor",
                    "hiliteColor",
                    "textStyle",
                ],
                ["removeFormat"],
                ["outdent", "indent"],
                [
                    ":e-More Line-default.more_horizontal",
                    "align",
                    "horizontalRule",
                    "list",
                    "lineHeight",
                ],
                [
                    ":r-More Rich-default.more_plus",
                    "table",
                    "link",
                    "image",
                    "video",
                    "audio",
                ],
            ],
        ],
        // (min-width: 480)
        [
            "%480",
            [
                ["undo", "redo"],
                [
                    ":p-More Paragraph-default.more_paragraph",
                    "font",
                    "fontSize",
                    "formatBlock",
                    "paragraphStyle",
                    "blockquote",
                ],
                [
                    ":t-More Text-default.more_text",
                    "bold",
                    "underline",
                    "italic",
                    "strike",
                    "subscript",
                    "superscript",
                    "fontColor",
                    "hiliteColor",
                    "textStyle",
                    "removeFormat",
                ],
                [
                    ":e-More Line-default.more_horizontal",
                    "outdent",
                    "indent",
                    "align",
                    "horizontalRule",
                    "list",
                    "lineHeight",
                ],
                [
                    ":r-More Rich-default.more_plus",
                    "table",
                    "link",
                    "image",
                    "video",
                    "audio",
                ],
            ],
        ],
    ];
}
